import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getAgentLog = id => {
  return http.get(
    `${getBaseUrl()}/agent_log/${id}`
  );
};

export const getUserAgentLog = agent_id => {
  return http.get(
    `${getBaseUrl()}/user_agent_log/${agent_id}`
  );
};

export const getAgentLogs = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_logs`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_logs?${paginate}`
  );
};

export const getAgentLogsPerson = () => {
  return http.get(
    `${getBaseUrl()}/agent_logs_person`
  );
};

export const createAgentLog = data => {
  return http.post(
    `${getBaseUrl()}/agent_log`,
    data
  );
};

export const createAgentLogNew = data => {
  return http.post(
    `${getBaseUrl()}/agent_log_new`,
    data
  );
};